import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_user",
  "aria-expanded": "true",
  "aria-controls": "kt_account_user"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Tambah User")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_user",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Full Name", -1)
const _hoisted_7 = { class: "col-5 fv-row" }
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Username", -1)
const _hoisted_12 = { class: "col-5 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Email", -1)
const _hoisted_17 = { class: "col-5 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Password", -1)
const _hoisted_22 = { class: "col-5 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label required fw-bold fs-6" }, "Role", -1)
const _hoisted_27 = { class: "col-5 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilih Role", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Administrator", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Operator", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "88" }, "Super Admin", -1)
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = {
  class: "row mb-6",
  style: {"display":"none"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 col-form-label fw-bold fs-6" }, "Avatar", -1)
const _hoisted_37 = { class: "col-10 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload text-white" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "JPG, JPEG, and PNG Only!", -1)
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}, " Reset ", -1)
const _hoisted_45 = {
  type: "submit",
  id: "kt_user_submit",
  ref: "submitSave",
  class: "btn btn-primary"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Harap Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        id: "kt_user",
        class: "form",
        novalidate: "novalidate",
        "validation-schema": _ctx.UserValidator,
        onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.simpanUser()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, {
                  type: "text",
                  name: "fullname",
                  class: "form-control form-control-lg",
                  placeholder: "Fullname",
                  modelValue: _ctx.UserForm.full_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.UserForm.full_name) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "fullname" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Field, {
                  type: "text",
                  name: "username",
                  class: "form-control form-control-lg",
                  placeholder: "Username",
                  modelValue: _ctx.UserForm.username,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.UserForm.username) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "username" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Field, {
                  type: "text",
                  name: "email",
                  class: "form-control form-control-lg",
                  placeholder: "Email",
                  modelValue: _ctx.UserForm.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.UserForm.email) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ErrorMessage, { name: "email" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_Field, {
                  type: "password",
                  name: "password",
                  class: "form-control form-control-lg",
                  placeholder: "Password",
                  modelValue: _ctx.UserForm.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.UserForm.password) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_ErrorMessage, { name: "password" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_Field, {
                  name: "role",
                  as: "select",
                  class: "form-select",
                  "aria-label": "Select example",
                  modelValue: _ctx.UserForm.role,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.UserForm.role) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_ErrorMessage, { name: "role" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_Field, {
                  type: "hidden",
                  name: "file_source",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.UserForm.photo,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.UserForm.photo) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_upload, {
                  ref: "upload",
                  class: "upload-demo",
                  action: _ctx.actionURL,
                  headers: _ctx.file_upload_header,
                  "on-success": _ctx.setFileUpload,
                  "before-remove": _ctx.removeFileUpload,
                  "on-remove": _ctx.cekFileSource,
                  "on-error": _ctx.errorFileUpload,
                  accept: _ctx.acceptFile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action", "headers", "on-success", "before-remove", "on-remove", "on-error", "accept"]),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_ErrorMessage, { name: "file_source" })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("button", _hoisted_45, _hoisted_48, 512)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}